import React from 'react';
import styles from './styles.module.scss';

export const RecaptchaFooter = () => {
  return (
    <div className={styles.copyright}>
      This site is protected by reCAPTCHA and the Google
      <br /> <a href="https://policies.google.com/privacy">
        Privacy Policy
      </a>{' '}
      and <a href="https://policies.google.com/terms">Terms of Service</a>{' '}
      apply.
    </div>
  );
};
